<template>
    <div class="m-2">
        <b-overlay :show="show" rounded="sm">
            <b-row v-if="totalRows > 0">
                <b-col lg="12" sm="12">
                    <statistic-card-horizontal
                        icon="AirplayIcon"
                        color="success"
                        :statistic="totalRows"
                    />
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="12" sm="12" class="mt-1">
                    <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="primary"
                        class="btn-icon float-right"
                        @click="confirmDelete()"
                    >
                        <feather-icon icon="XIcon" />
                        Eliminar todas las sesiones
                    </b-button>
                </b-col>
                <b-col lg="12" sm="12" class="mt-1">
                    <b-card no-body>
                        <b-table
                            striped
                            hover
                            ref="refUserListTable"
                            class="position-relative"
                            :items="items"
                            responsive
                            :fields="fields"
                            show-empty
                            empty-text="No existen registros para mostrar"
                            id="my-table"
                        >
                            <template #cell(id)="data">
                                {{ data.index + 1 }}
                            </template>

                            <template #cell(delete)="data">
                                <b-button
                                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                    variant="danger"
                                    class="btn-icon"
                                    @click="confirmDelete(data.item.id)"
                                >
                                    <feather-icon icon="XIcon" />
                                    Eliminar
                                </b-button>
                            </template>
                        </b-table>
                    </b-card>
                </b-col>
            </b-row>
        </b-overlay>
    </div>
</template>

<script>
import { BRow, BCol, BCard, BButton, BTable, BOverlay } from "bootstrap-vue";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
import Ripple from "vue-ripple-directive";

export default {
    components: {
        BRow,
        BCol,
        BCard,
        BButton,
        BTable,
        BOverlay,
        StatisticCardHorizontal
    },
    directives: {
        Ripple
    },
    data() {
        return {
            userData: JSON.parse(localStorage.getItem("userData")),
            show: false,
            fields: [
                { key: "id", label: "#", class: "text-white" },
                {
                    key: "device_name",
                    label: "Dispositivo",
                    sortable: true,
                    class: "text-white"
                },
                {
                    key: "created_at",
                    label: "Fecha",
                    sortable: true,
                    class: "text-white"
                },
                {
                    key: "country",
                    label: "Pais",
                    sortable: true,
                    class: "text-white"
                },
                { key: "delete", label: "Eliminar" }
            ],
            items: []
        };
    },
    created() {
        this.search();
    },
    methods: {
        search() {
            this.show = true;
            this.$http
                .get("api/user-sessions", {
                    params: {
                        idusuario: this.userData.id
                    }
                })
                .then(response => {
                    this.show = false;
                    this.items = response.data.data;
                })
                .catch(error => {
                    this.show = false;
                    console.log(error);
                });
        },
        confirmDelete(id) {
            let text = "";

            if (id != undefined) {
                text = "¿Seguro deseas eliminar la sesión?";
            } else {
                text = "¿Seguro deseas eliminar todas las sesiones?";
            }

            this.$swal({
                title: text,
                showCancelButton: true,
                confirmButtonText: "Si, continuar",
                customClass: {
                    title: "text-secondary",
                    confirmButton: "btn btn-secondary",
                    cancelButton: "btn btn-outline-secondary ml-1"
                },
                buttonsStyling: false
            }).then(result => {
                if (result.value) {
                    this.delete(id);
                }
            });
        },
        delete(id) {
            this.show = true;
            this.$http
                .post("api/user-sessions-delete", {
                    idusuario: this.userData.id,
                    id: id
                })
                .then(response => {
                    this.show = false;
                    this.search();
                })
                .catch(error => {
                    this.show = false;
                    console.log(error);
                    this.$swal({
                        title: "Error",
                        text: error.response.data.error,
                        icon: "error",
                        customClass: {
                            confirmButton: "btn btn-primary"
                        },
                        buttonsStyling: false
                    });
                });
        },
        showToast(message, variant, icon) {
            this.$toast({
                component: ToastificationContent,
                props: {
                    title: message,
                    variant: variant,
                    icon: icon
                }
            });
        }
    }, //fin methods
    computed: {
        totalRows() {
            return this.items.length;
        }
    }
};
</script>
